// Some simple dynamic heights
import debounce from "debounce";

const header = document.querySelector('.content__header');
const footer = document.querySelector('.content__footer');
const scrollableContent = document.querySelectorAll('.scrollable-content');
let footerHeight = footer ? footer.clientHeight : '';
let headerHeight = header ? header.clientHeight : '';

scrollableContent.forEach(content => content.style.setProperty('height', `${footerHeight}px`));

// Dynamic window height
function getViewHeight() {
  return window.innerHeight;
}

function setViewHeight() {
  let viewHeight = getViewHeight();

  document.querySelector(':root').style.setProperty('--height', `${viewHeight}px`);
  scrollableContent.forEach(content => content.style.setProperty('height', `${viewHeight - headerHeight - footerHeight}px`));
}

setViewHeight();

window.addEventListener('resize', debounce(function() {
  setViewHeight();
}, 250));
